import { LogOut } from "lucide-react";

const Sidebar = ({
  menuItems,
  activeMenu,
  sidebarOpen,
  unreadMessages,
  unreadNotifications,
  onMenuClick,
  onLogout
}) => {
  return (
    <aside
      className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-64 bg-[#000000] border-r border-[#1F1F1F]/70
        transform transition-transform duration-300 ease-in-out
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        flex flex-col
      `}
      data-testid="sidebar"
    >
      <div className="px-5 py-5 border-b border-[#1F1F1F]/70">
        <div className="text-white font-bold text-xl tracking-tight">
          Web-<span className="text-[#EDEDED]">3</span>
        </div>
      </div>

      <nav className="flex-1 py-3 px-2 space-y-1 overflow-y-auto">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeMenu === item.id;
          const hasSupportNotification = item.id === "support" && unreadMessages > 0;
          const hasNotifNotification = item.id === "notifications" && unreadNotifications > 0;

          return (
            <button
              key={item.id}
              onClick={() => onMenuClick(item)}
              className={`
                w-full flex items-center gap-3 px-3.5 py-3 text-left rounded-lg transition-all relative
                ${isActive
                  ? "bg-[#FF8A1E]/12 text-[#FF8A1E] font-semibold"
                  : "text-[#A1A1AA] hover:bg-white/5 hover:text-white"
                }
              `}
              data-testid={`menu-${item.id}`}
            >
              {isActive && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-6 w-1 rounded-r bg-[#FF8A1E]" />
              )}
              <Icon size={19} className={isActive ? "text-[#FF8A1E]" : ""} />
              <span className="text-sm">{item.label}</span>
              {(hasSupportNotification || hasNotifNotification) && (
                <span className="absolute right-3 min-w-[18px] h-[18px] px-1 bg-[#F87171] rounded-full text-white text-[10px] flex items-center justify-center font-bold">
                  {hasSupportNotification ? unreadMessages : unreadNotifications}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="border-t border-[#1F1F1F]/70 p-2">
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-3.5 py-3 rounded-lg text-[#A1A1AA] hover:bg-white/5 hover:text-[#F87171] transition-all text-sm"
          data-testid="logout-btn"
        >
          <LogOut size={19} />
          <span>Выход</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
